import ru from "vuetify/src/locale/ru";

export default {
  $vuetify: ru,
  ru: "RU",
  kk: "KZ",
  hello: "Privet",
  attention: "Внимание",
  cancel: "Отмена",
  update: "Обновить",
  close: "Закрыть",
  "no-data": "Нет данных",
  back: "Назад",
  summary: "Итого",
  expand: "Развернуть",
  questionnaire: {
    fio: "ФИО:",
    notice:
      "Уважаемый потребитель! С целью улучшения качества оказываемых услуг просим ответить на вопросы <u> нашей Анкеты!</u>",
    title: "Анкета оценки удовлетворенности потребителей - физических лиц",
    title1: "Уважаемый потребитель!",
    title21:
      "Филиал АО «Алатау Жарық Компаниясы» - «Энергосбыт» стремится узнать Ваше мнение о своей деятельности с целью улучшения качества оказываемых услуг и реализуемой продукции. Просим Вас ответить на вопросы, и специалисты Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт» обязательно учтут Ваше мнение в своей дальнейшей работе!",
    title3: "Просим Вас принять участие!",
    title4: "Наименование Вашего предприятия:",
    title5: "Мы благодарим  Вас за оказанное содействие!",
    "question-number": "Вопрос №{num} из {count}",
    send: "Отправить анкету",
    next: "Далее",
    fill: "Укажите перечень товаров/услуг",
    select:
      "Оцените по 5-балльной шкале степень Вашей удовлетворенности работой Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт» 1 – плохо, 2 - неудовлетворительно, 3 - удовлетворительно, 4 - хорошо, 5 – отлично",
  },
  ui: {
    yes: "да",
    no: "нет",
    attention: "Внимание",
    cancel: "Отмена",
    update: "Обновить",
    close: "Закрыть",
    wait: "Пожалуйста, подождите...",
    user: "Пользователь",
    document_loading:
      "Ваш документ загружается и будет открыт в этом окне. Пожалуйста, подождите...",
  },
  "app-navigation": {
    "account-list": "Доступные лицевые счета",
    "account-info": "Информация по лицевому счету",
    "home-tooltip": "Список лицевых счетов",
    "exit-tooltip": "Выход",
    "profile-tooltip": "Профиль пользователя",
    "service-info": "Информация по услугам",
    calculate: "Расчет начислений по эл. энергии",
    pays: "Платежи",
    invoices: "Квитанции",
    requests: "Подать заявку",
    "change-pwd": "Изменить пароль",
    "change-email": "Изменение E-mail",
    "change-personal": "Персональные настройки",
  },
  reportsInfo: { "no-data": "Нет данных за выбранный период" },
  "update-checker": {
    message:
      'Доступна новая версия Личного кабинета.<br /><br /> Обновить? <br /><br />Нажмите "Обновить", чтобы перезагрузить страницу. Все введённые данные при этом будут утеряны.',
  },
  maintenance: {
    message:
      '<center><b>Внимание!</b> <span style="font-weight: 400"> <br /><br /> Ведутся технические работы. <br /><br /> Приносим извинения <br /> за доставленные неудобства.</span> </center>',
  },
  "app-header": {
    feedback: "Обратная связь",
    "contact-center": "Круглосуточный контакт-центр 356-99-99",
    departments: "Районные отделения АлматыЭнергоСбыт (РОЭС)",
    "invoice-sign": "Подписаться на электронную квитанцию",
    iconMapSite: "Карта сайта",
  },
  "app-footer": {
    text: "Филиал АО «АЖК»-Энергосбыт. Разработано АО «АЛСЕКО»",
  },
  "auth-view": {
    title: "Личный кабинет для физических лиц",
    enter: "Вход",
    login: "Логин",
    password: "Пароль",
    enter_pass: "Требуется пароль",
    back: "<< Назад ко Входу",
    forgot: "Забыли пароль?",
    restore: "Восстановление пароля от Личного кабинета",
    message1:
      "После подтверждения запроса на восстановление пароля вы получите письмо с инструкциями по восстановлению пароля.",
    message2:
      "Восстановление пароля возможно только при условии подтверждения электронного адреса в Личном кабинете. ",
    confirm: "Подтвердить",
    "send-restore-mail":
      "На ваш электронный адрес направлена инструкция по восстановлению пароля. Проверьте вашу почту.",
    notice:
      "Вход в Личный кабинет по электронному адресу возможен только при условии подтверждения электронного адреса в Личном кабинете. ",
    updated: "Ваш пароль успешно сменён. Вы можете выполнить ",
    updated2: " с новым паролем.",
    "new-passw": "Новый пароль",
    "retry-pass": "Подтверждение пароля",
  },
  "form-validator": {
    required: "Поле, обязательное для заполнения",
    "string-max": "Максимальная длина строки {max} символов",
    "string-min": "Минимальная длина строки {min} символов",
    email: "Введён некорректный email",
    number: "Введено некорректное число",
    decimal3: "Числовое поле, 10 знаков с точностью до тысячных",
    checkMoreWhen: "Последующие показания должны быть больше предыдущих",
    accountId: "Некорректный номер Л.С.",
    pass_rep_incorr: "Введенные значения паролей не совпадают",
    pass:
      "Введенный пароль не соответствует требованиям безопасности. Новый пароль должен содержать: Минимум 8, максимум 12 символов; 1 цифру; 1 букву латинского алфавита в верхнем регистре; 1 букву латинского алфавита в нижнем регистре; 1 специальный символ (@#$%&); Для ввода использовать только буквы латинского алфавита;",
    pass_create: "Введите новый пароль для входа в кабинет пользователя",
    link_expired:
      "Срок действия данной ссылки истек. Нажмите «Восстановить пароль» для получения новой ссылки.",
    link_expired2: "Ссылка устарела или была использована ранее",
    decimal2: "Числовое поле, 10 знаков с точностью до сотых",
    decimal: "Числовое поле, 10 знаков",
    checkDates: "Указана некорректная дата последнего снятия показаний",
  },
  "app-menu": {
    "account-list": "Доступные лицевые счета",
    "account-info": "Информация по лицевому счету",
    "service-info": "Информация по услугам",
    calculate: "Расчет начислений по эл. энергии",
    pays: "Платежи",
    invoices: "Квитанции",
    requests: "Подать заявку",
    "change-pwd": "Изменить пароль",
    "change-email": "Изменение E-mail",
    "change-personal": "Персональные настройки",
  },
  "account-info": {
    add: "Добавить новый лицевой счет",
    addB: "Добавление нового Лицевого счета",
    accNum: "№ лицевого счета",
    month: "Месяц и год последней оплаты",
    sumLastPay: "Сумма последней оплаты",
    addBtn: "Добавить",
    "account-exists": "У вас уже добавлен лицевой счет с таким номером",
    "account-not-exists":
      "ТОО «АлматыЭнергоСбыт» не является поставщиком электроэнергии по лицевому счету №{account}",
    InvalidPayDate: "Оплата не найдена в базе данных.",
    InvalidPaymentSum: "Сумма оплаты не соответствует последнему платежу.",
    "add-error": "Не удалось добавить лицевой счет. Попробуйте позже.",
    "add-invalid-data":
      "Лицевой счет не найден, либо неверно указаны месяц или сумма последней оплаты. Проверьте введенные данные.",
    "add-too-many-attempts":
      "Превышено количество попыток ввода данных по лицевому счету. Повторите через {minutes} мин.",
    delete: "Вы действительно хотите удалить лицевой счет №{account}?",
    qty: "Количество постоянно проживающих",
    info: "Информация по лицевому счету №{AccountId}",
    payer: "Плательщик",
    adres: "Адрес",
    poverka: "Дата поверки счетчиков",
    poverkatext:
      "У каждого счетчика есть поверочный период, т.е. подразумевается, что в этом периоде счетчик работает исправно. Это указано в паспорте на счетчик. После того, как этот период заканчивается, то гарантии, что он работает верно нет, поэтому он должен пройти поверку или его нужно заменить",
    change: "Дата замены счетчиков",
    electro: "Электроэнергия",
    changes: "Счетчик №: {number}",
    // changes2: ", дата следующей гос. поверки: {date}",
    changes2: "",
  },
  "service-info": {
    title: "Информация по услугам (Платежи учтены на {date})",
    serv: "Наименование услуги",
    period_start: "Выбор периода с",
    period_end: "по",
    supplier: "Поставщик:",
    "year-month": "Месяц/Год",
    "begin-saldo": "Начальное сальдо",
    calc: "Начисление",
    edits: "Корректировки",
    pays: "Платежи",
    saldo: "Конечное сальдо",
    print: "Печать",
  },
  calculate: {
    title: "Расчет начислений по электроэнергии",
    counter: "Счетчик",
    number: "№ счетчика:",
    install: "Дата установки:",
    type: "Тип:",
    prev: "Предыдущая дата снятия и показания электросчетчика",
    data: "Дата",
    counts: "Показания",
    current: "Последующая дата снятия и показания электросчетчика",
    calc: "Рассчитать",
    counts_day: "Показания день",
    counts_nigth: "Показания ночь",
  },
  pays: {
    title: "Платежи",
    date: "Дата",
    "sum-pay": "Сумма оплаты",
    bank: "Банк",
    info: "Информация по оплате:",
    serv: "Наименование услуги",
    sum_pay: "Оплаченная сумма в тенге",
  },
  invoices: {
    title: "Квитанции",
    "year-month": "Месяц/Год",
    fix_summ: "Сумма к оплате",
    kvit: "Квитанция",
    oborot: "Оборотная сторона счета",
    serv: "Наименование услуги",
    info: "Информация по квитанции:",
    view: "Просмотр",
  },
  "change-pwd": {
    title: "Изменить пароль",
    old: "Текущий пароль",
    new: "Новый пароль",
    retry: "Подтверждение пароля",
    save: "Сохранить",
    incorrectCurrent:
      "Прежний пароль введён неправильно. Если Вы забыли его, то воспользуйтесь системой восстановления пароля",
    newAndOld: "Новый пароль должен отличаться не менее чем на один символ",
    newPwdSetted: "Новый пароль установлен",
    tooManyAttempts:
      "Превышено количество попыток ввода текущего пароля. Повторите через {minutes} мин.",
    error: "Не удалось изменить пароль. Попробуйте позже.",
  },
  personal: {
    title: "Персональные настройки",
    firstname: "Фамилия",
    lastname: "Имя",
    middlename: "Отчество",
    dataUpdated: "Персональные настройки сохранены",
  },
  "change-email": {
    title: "Изменение E-mail адреса",
    email: "Введите новый E-mail адрес для изменения",
    exists: "Пользователь с таким электронным адресом уже существует.",
    nothing: "Введенный E-mail соответсвует текущему",
    EmailActivationInfo:
      "Для продолжения изменения Email адреса вам необходимо подтвердить изменение. Инструкция по подтверждению изменения была отправлена на Ваш электронный адрес.",
    EmailChanged: "Изменение Email адреса прошло успешно.",
    secretHashNotFound: "Ссылка устарела или была использована ранее",
    secretHashExpired: "Ссылка устарела или была использована ранее",
  },
  registr: {
    btn: "Зарегистрироваться",
    title: "Регистрация",
    att: "Внимание.",
    know: "Для продолжения регистрации Вам необходимо знать",
    "sum-day": " сумму и дату последней оплаты",
    enter: "Информация для входа",
    test: "Проверочная информация",
    cancel: "Отмена",
    days:
      "Оплата, произведенная через терминалы и отделения банков, поступает на счет в течение 3-4 рабочих дней",
    pays:
      "Общая сумма оплаты по квитанции АО АЛСЕКО, включая тиын через точку. Дата платежа рассматривается за последние 6 месяцев.",
    RegistrationError: "Не удалось выполнить регистрацию. Попробуйте позже.",
    RegistrationSuccess:
      "Регистрация прошла успешно. Для продолжения работы с личным кабинетом Вам необходимо ввести свой Email и пароль.",
    requared: "Поля обязательные для заполнения",
  },
};
